import { Button, Popover, Switch } from "antd";
import { SettingOutlined } from "@ant-design/icons";

/**
 * Settings cog for the brand lookup page. Fully controlled — each setting's
 * value and change handler is passed in. Structured so more settings can be
 * added as rows in the popover.
 */
export const Settings = ({
    recentBrandsOn = false,
    onRecentBrandsChange,
    coolerSearch = false,
    onCoolerSearchChange,
}) => {
    const settingsContent = (
        <div
            style={{
                width: 320,
                display: "flex",
                flexDirection: "column",
                gap: 12,
            }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                }}>
                <span style={{ flex: 1 }}>Recent brands</span>
                <Switch
                    checked={recentBrandsOn}
                    onChange={onRecentBrandsChange}
                />
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                }}>
                <span style={{ flex: 1 }}>😎 Cooler search</span>
                <Switch
                    checked={coolerSearch}
                    onChange={onCoolerSearchChange}
                />
            </div>
        </div>
    );

    return (
        <Popover
            content={settingsContent}
            title="Settings"
            trigger="click"
            placement="bottomRight">
            <Button icon={<SettingOutlined />} />
        </Popover>
    );
};
